import type { Provenance } from '../../api/admin.api';

/** What a draft field's origin is called on the page. */
export const PROVENANCE_LABEL: Record<Provenance, string> = {
  frontmatter: "from the file's frontmatter",
  metadata: "from the file's augment-toolkit metadata",
  'repo-file': "from the repository's augment-toolkit.yaml",
  overlay: 'entered here earlier',
  derived: 'worked out from the file',
  missing: 'missing',
};

/**
 * **The cascade, seen from the page.** A value the repository itself holds is read
 * only here: the toolkit's own entry fills a gap and never overrules what a maintainer
 * wrote, so offering an input over one would be offering something that has no effect.
 */
export const isEditable = (from: Provenance): boolean =>
  from === 'missing' || from === 'derived' || from === 'overlay';
